import * as React from 'react';

import Icon, { IconSizes } from '@Components/Icon';
import Image from '@Components/Image';
import Container from '@Components/layout/Container';
import Layout from '@Components/layout/Layout';
import Typography from '@Components/Typography';
import { useTranslations } from '@Hooks/useTranslations';
import TractorImage from '@Images/farmer.jpg';

import NewsletterSection from '../LandingPage/IntroPage/NewsletterSection';

import styles from './AboutPage.module.scss';

const AboutPage = () => {
  const t = useTranslations();

  return (
    <Layout className={styles.layout}>
      <div className={styles.grayContainer}>
        <Container>
          <div className={styles.titleContainer}>
            <Typography tag="h2" msg={t('msg_about_page_title')} />
            <Typography tag="p" msg={t('msg_about_page_subtitle')} />
          </div>
        </Container>
      </div>
      <div className={styles.advantagesContainer}>
        <Container>
          <div className={styles.advantagesBlock}>
            <div className={styles.advantageItem}>
              <Icon icon="tractor" size={IconSizes.l} />
              <Typography tag="p" msg={t('msg_about_page_advantage_title_1')} size="l" bold />
              <Typography tag="p" size="m" msg={t('msg_about_page_advantage_subtitle_1')} />
            </div>
            <div className={styles.advantageItem}>
              <Icon icon="farmer" size={IconSizes.l} />
              <Typography tag="p" msg={t('msg_about_page_advantage_title_2')} size="l" bold />
              <Typography tag="p" size="m" msg={t('msg_about_page_advantage_subtitle_2')} />
            </div>
            <div className={styles.advantageItem}>
              <Icon icon="hand-with-plant" size={IconSizes.l} />
              <Typography tag="p" msg={t('msg_about_page_advantage_title_3')} size="l" bold />
              <Typography tag="p" size="m" msg={t('msg_about_page_advantage_subtitle_3')} />
            </div>
          </div>
        </Container>
      </div>
      <Container className={styles.benefitsSection}>
        <div className={styles.benefitsContainer}>
          <Typography tag="p" msg={t('msg_about_page_benefits_section_title')} size="xl" bold />
          <Typography
            tag="p"
            msg={t('msg_about_page_benefits_section_subtitle')}
            size="m"
            className={styles.benefitsSubtitle}
          />

          <div className={styles.benefit}>
            <Icon icon="arrow-trending-up" size={IconSizes.m} />
            <Typography tag="p" msg={t('msg_about_page_benefits_section_benefit_1')} size="s" />
          </div>
          <div className={styles.benefit}>
            <Icon icon="check-circle" size={IconSizes.m} />
            <Typography tag="p" msg={t('msg_about_page_benefits_section_benefit_2')} size="s" />
          </div>
          <div className={styles.benefit}>
            <Icon icon="currency-euro-outlined" size={IconSizes.m} />
            <Typography tag="p" msg={t('msg_about_page_benefits_section_benefit_3')} size="s" />
          </div>
          <div className={styles.benefit}>
            <Icon icon="calendar-days" size={IconSizes.m} />
            <Typography tag="p" msg={t('msg_about_page_benefits_section_benefit_4')} size="s" />
          </div>
          <div className={styles.benefit}>
            <Icon icon="tractor" size={IconSizes.m} className={styles.tractorIcon} />
            <Typography tag="p" msg={t('msg_about_page_benefits_section_benefit_5')} size="s" />
          </div>
        </div>

        <Image src={TractorImage} alt="farmer" className={styles.farmerImage} />
      </Container>

      <NewsletterSection />
    </Layout>
  );
};

export default AboutPage;
